import AccueilView from "@/views/AccueilView";
import MesAssociations from "@/views/MesAssociations";
import RouterView from "@/views/RouterView";
import CreationView from "@/views/creation/CreationView";
import DepotView from "@/views/creation/DepotView";
import DemandePiecesView from "@/views/pieces/DemandePiecesView";
import { authentified } from "./AccesDecisions";

export default [
  {
    path: "/",
    component: RouterView,
    children: [
      {
        path: "",
        redirect: () => ({ name: "accueil" }),
      },
      { path: "accueil", name: "accueil", component: AccueilView,
        meta: {
         auth: authentified()
        }
      },
      { path: "/mes-associations", name: "mes-associations", component: MesAssociations,
        meta: {
         auth: authentified()
        }
      },
      {
        path: "creation",
        name: "creation",
        component: CreationView,
        meta: {
          auth: authentified()
        }
      },
      {
        path: "consultation/depot/:id",
        component: DepotView,
        props: true,
        meta: {
          auth: authentified()
        }
      },
      {
        name: "pieces",
        path: "pieces/:id",
        component: DemandePiecesView,
        props: true,
      }
    ]
  },
];
